import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { HomeSectionContainer } from './home_section';
import { ApiContext } from './context';
import { sectionPath } from '../../lib/config';

import './home.css';

const Home = props => {
	const { news, articles, main } = props.viewer;
	return (
		<ApiContext.Provider value={{ refetch: props.relay.refetch }}>
			<div className="home_container">
				<HomeSectionContainer
					placeholderHint="На основной баннер"
					viewer={props.viewer}
					limit={1}
					uuid="main"
					title="Главное сегодня"
					edges={main.edges}
				/>
				<HomeSectionContainer section={sectionPath.news} viewer={props.viewer} limit={4} uuid="news" title="Новости" edges={news.edges} />
				<HomeSectionContainer
					section={sectionPath.article}
					viewer={props.viewer}
					limit={3}
					uuid="articles"
					title="Статьи"
					edges={articles.edges}
				/>
			</div>
		</ApiContext.Provider>
	);
};

export default createRefetchContainer(
	Home,
	{
		viewer: graphql`
			fragment home_viewer on Viewer {
				...ArticleSelector_viewer
				main: articles(first: 1, hidden: false, h: true) {
					edges {
						node {
							id
							slug
							mainPageOrder
							title
							categoryName
							availableAt
							preview {
								filename
								type
								preview
							}
						}
					}
				}
				news: articles(first: 3, section: "U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=", d: true, h: false, hidden: false) {
					edges {
						node {
							id
							slug
							title
							mainPageOrder
							categoryName
							availableAt
							preview {
								filename
								type
								preview
							}
						}
					}
				}
				articles: articles(first: 3, section: "U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=", d: true, h: false, hidden: false) {
					edges {
						node {
							id
							slug
							mainPageOrder
							title
							categoryName
							availableAt
							preview {
								filename
								type
								preview
							}
						}
					}
				}
			}
		`,
	},
	graphql`
		query home_Refetch_Query {
			viewer {
				...home_viewer
			}
		}
	`,
);



// WEBPACK FOOTER //
// src/components/home/home.js